import type {
    DurationInMinutes} from "@@/shared/date-time/time-spans";
import {
    durationInMinutesZodSchema,
} from "@@/shared/date-time/time-spans";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    ResourceIntervalId} from "./resource-schedule-interval-id";
import {
    resourceScheduleIntervalIdFactory,
    resourceScheduleIntervalIdZodSchema,
} from "./resource-schedule-interval-id";

type ResourceScheduleInterval = {
    _id: string;
    _type: "RESOURCE_SCHEDULE_INTERVAL";
    fromSessionStart: DurationInMinutes | "START" | "END";
    duration: DurationInMinutes | "END";
};

const resourceScheduleIntervalFactory = (
    params: Except<ResourceScheduleInterval, "_id" | "_type"> & {
        _id?: ResourceIntervalId;
    },
): ResourceScheduleInterval => {
    return {
        ...params,
        _id: params._id ?? resourceScheduleIntervalIdFactory(),
        _type: "RESOURCE_SCHEDULE_INTERVAL",
    };
};

const resourceScheduleIntervalZodSchema: z.ZodSchema<ResourceScheduleInterval> =
    z.object({
        _id: resourceScheduleIntervalIdZodSchema,
        _type: z.literal("RESOURCE_SCHEDULE_INTERVAL"),

        fromSessionStart: z.union([
            durationInMinutesZodSchema,
            z.enum(["START", "END"]),
        ]),
        duration: z.union([durationInMinutesZodSchema, z.enum(["END"])]),
    });

export { resourceScheduleIntervalFactory, resourceScheduleIntervalZodSchema };
export type { ResourceScheduleInterval };
